import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";

const TimecardService = {
  insertOrUpdateTimecard(obj) {
    return httpClient.post(endPoints.insertOrUpdateTimecard, obj);
  },
  syncAttendance(obj) {
    return httpClient.post(endPoints.syncAttendance, obj);
  },
  updateTimeCard(obj) {
    return httpClient.post(endPoints.updateTimeCard, obj)
  }
};

export default TimecardService;



// WEBPACK FOOTER //
// ./src/service/TimecardService.js